






















































































import { defineComponent, ref, reactive, onMounted, PropType, watch } from '@vue/composition-api';

interface VoiceClassForm {
  name: string;
  description: string;
  thumbnail: string;
  video: string;
  duration: number;
  instructor: string;
  file?: File;
}

export default defineComponent({
  name: 'VoiceClassBaseForm',
  props: {
    initialData: {
      type: Object as PropType<VoiceClassForm>,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit, refs}) {
    const form = ref<any>(null);
    const valid = ref(true);
    const thumbnailFile = ref<File | null>(null);
    const fileReader = ref<FileReader | null>(null);
    const formData = reactive<VoiceClassForm>({
      name: '',
      description: '',
      instructor: '',
      thumbnail: '',
      video: '',
      duration: 0,
    });

    const nameRules = [
      (v: string) => !!v || 'Name is required',
      (v: string) => v.length <= 100 || 'Name must be less than 100 characters',
    ];

    const instructorRules = [
      (v: string) => !!v || 'Instructor is required',
      (v: string) => v.length <= 100 || 'Instructor must be less than 100 characters',
    ];

    const descriptionRules = [
      (v: string) => !!v || 'Description is required',
    ];

    const thumbnailRules = [
      (v: File) => props.isEdit || (!!v || !!formData.thumbnail) || 'Thumbnail is required',
      (v: File) => !v || v.size < 2000000 || 'Thumbnail size should be less than 2 MB',
    ];

    const videoRules = [
      (v: string) => !!v || 'Video URL is required',
      (v: string) => /^https?:\/\/.+/.test(v) || 'Must be a valid URL',
    ];

    const durationRules = [
      (v: number) => !!v || 'Duration is required',
      (v: number) => v > 0 || 'Duration must be greater than 0',
    ];

    watch(() => props.initialData, () => {
      Object.assign(formData, props.initialData);
    }, { deep: true, immediate: true });


    const handleThumbnailChange = (file: File) => {
      if (!file) {
        formData.thumbnail = props.initialData?.thumbnail || '';
        formData.file = undefined;
        return;
      }

      fileReader.value = new FileReader();
      fileReader.value.onload = (e) => {
        if (e.target?.result) {
          formData.thumbnail = e.target.result as string;
          formData.file = file;
        }
      };
      fileReader.value.readAsDataURL(file);
    };

    const submit = () => {
      if (form.value?.validate()) {
        emit('submit', {...formData});
      }
    };

    return {
      form,
      valid,
      formData,
      thumbnailFile,
      nameRules,
      instructorRules,
      descriptionRules,
      thumbnailRules,
      videoRules,
      durationRules,
      handleThumbnailChange,
      submit,
    };
  },
});
